import { useContext } from 'react';
import UserInfoContext from '../contexts/UserInfoContext';
export function useUserInfo() {
  "use memo";

  return useContext(UserInfoContext);
}